import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { WorkflowService, WorkflowStatuses } from '../_services/workflow.service';
import { CreateWorkflowDialogComponent } from '../create-workflow-dialog/create-workflow-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LayoutUtilsService, MessageType } from '../../../../core/_base/crud';
import { ConfirmActionDialogComponent } from '../../../partials/content/crud';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/core/reducers';
import { currentUser, User } from 'src/app/core/auth';
import { Subscription } from 'rxjs';
import { UserService } from '../../../../core/auth/_services';
import { uniqWith, isEqual } from 'lodash-es';
import { take } from 'rxjs/operators';
import { FollowUpService } from '../../../../core/services/follow-up.service';
import { CommentsService } from '../../../../core/services/comments.service';
import { CommentsDialogComponent } from '../../../partials/content/general/comments-dialog/comments-dialog.component';
import { Blocker } from '../../../../core/models';

@Component({
  selector: 'kt-workflow-accordion',
  templateUrl: './workflow-accordion.component.html',
  styleUrls: ['./workflow-accordion.component.scss'],
})
export class WorkflowAccordionComponent implements OnInit, OnDestroy {
  @Input() statusesList;
  @Input() workflow;
  @Input() header;
  @Input() users;
  @Input() entities;
  @Input() drugs;
  @Input() contacts;
  @Input() userSymbol;
  @Input() checkValues;
  @Output() refreshWorkflowList = new EventEmitter<any>();
  hasDescription = true;
  locked = false;
  lockedBy = '';
  currentUser;
  subscriptions: Subscription[] = [];
  userExist = false;
  userProfile;
  workflowEntities = [];
  workflowDrugs = [];
  workflowDoctors = [];
  workflowPatients = [];
  workflowClients = [];
  workflowFacilities = [];
  workflowPharmacies = [];
  workflowPharmacyGroups = [];
  workflowContacts = [];
  assignedUsers: User[] = [];
  sort: { label: string; type: 'ASC' | 'DESC' } = { label: '', type: 'DESC' };

  constructor(
    public dialog: MatDialog,
    private userService: UserService,
    private workflowService: WorkflowService,
    private followUpService: FollowUpService,
    private commentsService: CommentsService,
    private layoutUtilsService: LayoutUtilsService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
  ) {}
  ngOnInit(): void {
    if (!this.header) {
      const assignedUsersId = uniqWith<number>(
        this.workflow.workflow_queue.responsible_users.map((user) => user.responsible_id, isEqual),
      );
      if (assignedUsersId.length)
        this.userService
          .getUsersById(assignedUsersId)
          .pipe(take(1))
          .subscribe(({ pageOfItems }) => {
            this.assignedUsers = pageOfItems;
            this.cdr.detectChanges();
          });

      this.subscriptions.push(
        this.store.pipe(select(currentUser)).subscribe((res) => (this.currentUser = res.userName)),
      );
      this.locked =
        this.workflow.workflow_queue.lock &&
        this.workflow.workflow_queue.locked_by.trim() !== this.currentUser.trim();
      if (this.locked) {
        this.lockedBy = this.workflow.workflow_queue.locked_by;
      }
      if (
        this.checkValues &&
        this.checkValues.workflow_queue_id === this.workflow.workflow_queue.id &&
        this.checkValues.workflow_action_id === this.workflow.workflow_action.id
      ) {
        this.openEditFlowModal();
      }
      if (this.users && this.users.length > 0) {
        const u = this.users.find((e) => e.userName === this.workflow.last_modified_user);
        if (u) {
          this.userProfile = u;
          this.userExist = true;
          this.cdr.detectChanges();
        }
        this.workflowContacts = this.getArrayForPrint(this.workflowContacts, 'CONTACT');
        this.workflowDrugs = this.getArrayForPrint(this.workflowDrugs, 'DRUG');
        this.workflowClients = this.getArrayForPrint(this.workflowClients, 'CLIENT');
        this.workflowDoctors = this.getArrayForPrint(this.workflowDoctors, 'DOCTOR');
        this.workflowPatients = this.getArrayForPrint(this.workflowPatients, 'PATIENT');
        this.workflowPharmacies = this.getArrayForPrint(this.workflowPharmacies, 'PHARMACY');
        this.workflowPharmacyGroups = this.getArrayForPrint(
          this.workflowPharmacyGroups,
          'PHARMACY_GROUP',
        );
        this.workflowFacilities = this.getArrayForPrint(this.workflowFacilities, 'FACILITY');
      }
    }
  }
  getArrayForPrint(arr, arrName) {
    const current = this.workflow.workflow_queue.workflow_queue_entities;
    current.forEach((element) => {
      if (element && element.type === arrName) arr = arr.concat(element.ids);
      arr = this.arrayUnique(arr);
    });
    return arr;
  }
  arrayUnique(array) {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  }

  getEntity(entity) {
    const res = '';
    if (!entity) {
      return res;
    } else {
      const u = this.entities.find((e) => e.id === entity);
      if (u) {
        return '' + this.getTip(u.first_name, u.last_name);
      }
      return res;
    }
  }
  getContact(entity) {
    const res = '';
    if (!entity) {
      return res;
    } else {
      const u = this.contacts.find((e) => e.id === entity);
      if (u) {
        return '' + this.getTip(u.first_name, u.last_name);
      }
      return res;
    }
  }
  getDrug(entity) {
    const res = '';
    if (!entity) {
      return res;
    } else {
      const u = this.drugs.find((e) => e.id === entity);
      if (u) {
        return '' + this.getTip(u.drug, '');
      }
      return res;
    }
  }
  getTip(last, first) {
    let res = '';
    if (last) {
      res = res + last;
    }
    if (first) {
      res = res + ' ' + first;
    }
    return res;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
  getAllAtt(obj, withItem = false) {
    let str = ' ';
    // tslint:disable-next-line:forin
    for (const item in obj) {
      if (withItem) {
        // str += '<span class="text-muted mr-3 font-weight-bold font-size-sm">'
        str += '<span class="text-primary text-dark-50 ">' + ' ' + obj[item] + '</span>';
        // str += item[0].toUpperCase() + item.substr(1).toLowerCase().replace('_',' ') + ': <span class="text-primary font-weight-bolder">'+' '+obj[item]+'</span></span>
        continue;
      }
      str += obj[item] + '  ';
    }
    return str;
  }
  getClassBasedOnStatus() {
    let classSet = 'border-left rounded-left border-warning';
    switch (this.workflow.workflow_queue.status) {
      case WorkflowStatuses.IN_PROGRESS:
        classSet += 'border-warning';
        break;
      case WorkflowStatuses.PENDING:
        classSet += 'border-secondary';
        break;
      case WorkflowStatuses.READY:
        classSet += 'border-primar';
        break;
      case WorkflowStatuses.REVIEW:
        classSet += 'border-success';
        break;
    }
    return classSet;
  }

  getHeader() {
    let current = '<div class="d-flex align-items-center flex-wrap">';
    const jsonObject = JSON.parse(this.workflow.workflow_queue.input_data);
    // tslint:disable-next-line:forin
    for (const item in jsonObject) {
      // current += '<div class="d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3">'
      current +=
        '<span class="text-muted mr-3 font-weight-bold font-size-sm ' +
        (item === 'patient' ? 'gl-block' : '') +
        '">' +
        item[0].toUpperCase() +
        item.substr(1).toLowerCase() +
        ': ';
      // current += '<div class="d-flex align-items-center flex-lg-fill mr-5">'
      current += this.getAllAtt(jsonObject[item].attributes, true);
      current += ' </span>';
    }
    return current + ' </div>';
  }

  openEditFlowModal() {
    const dialogRef = this.dialog.open(CreateWorkflowDialogComponent, {
      data: {
        workflow: this.workflow,
        isNew: false,
        header: this.getHeader(),
        statuses: this.statusesList,
      },
      width: '90vw',
      maxWidth: 'unset !important',
      disableClose: true,
      hasBackdrop: true,
      closeOnNavigation: true,
      autoFocus: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && (result.reloadWorkflow || result.cancelledWorkflowId)) {
        this.refreshWorkflowList.emit({
          workflow_action_id: result.workflow_action_id,
          workflow_queue_id: result.workflow_queue_id,
        });

        return;
      }

      this.refreshWorkflowList.emit();
    });
  }

  unlockCard() {
    const dialogRef = this.dialog.open(ConfirmActionDialogComponent, {
      data: {
        title: 'Unlock Card',
        description: 'Are you sure to force unlock the card?',
        waitDesciption: 'Unlocking ...',
      },
      width: '440px',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.workflowService.lockWorkflow(this.workflow.workflow_queue.id, false).subscribe(() => {
        this.locked = false;
        this.workflow.workflow_queue.lock = true;
        this.layoutUtilsService.showActionNotification(
          'Workflow successfully Unlocked',
          MessageType.Read,
          3000,
          false,
          false,
        );
        setTimeout(() => {
          this.openEditFlowModal();
        }, 500);
        this.cdr.detectChanges();
      });
    });
  }

  clickPin(workflowQueue) {
    const dialogRef = this.dialog.open(ConfirmActionDialogComponent, {
      data: {
        title: workflowQueue.expedite_pin ? 'Unpin' : 'Pin',
        // tslint:disable-next-line:max-line-length
        description: workflowQueue.expedite_pin
          ? 'Are you sure you want to unpin this workflow?'
          : 'Are you sure you want to pin this workflow',
        waitDescription: workflowQueue.expedite_pin ? 'Unpin ...' : 'Pin ...',
      },
      width: '440px',
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.workflowService
        .updateExpedite(workflowQueue.id, !workflowQueue.expedite_pin)
        .subscribe(() => {
          this.layoutUtilsService.showActionNotification(
            workflowQueue.expedite_pin
              ? 'Workflow successfully unpinned'
              : 'Workflow successfully pinned',
            MessageType.Read,
            3000,
            false,
            false,
          );
          setTimeout(() => {
            this.refreshWorkflowList.emit({});
          }, 500);
          this.cdr.detectChanges();
        });
    });
  }

  getPinCSS(workflowQueue: any) {
    if (!workflowQueue.expedite_pin) {
      return 'btn svg-icon svg-icon-sd p-0  pr-3';
    }
    return 'btn svg-icon svg-icon-warning svg-icon-sd p-0  pr-3';
  }
  getCategoryName(category) {
    if (category) {
      return category.category_name;
    }
  }

  getFullNames(users: User[], startIdx: number): string {
    let fullNames = '';

    users.slice(startIdx).forEach((user) => (fullNames += `${user.fullName}\n`));

    return fullNames;
  }

  openFollowUp(event: Event): void {
    event.stopPropagation();

    if (!this.workflow.has_followup) return;

    let entitiesIds = [];

    this.workflow.workflow_queue.workflow_queue_entities.forEach(
      (entity) => (entitiesIds = [...entitiesIds, ...entity.ids]),
    );

    this.followUpService.openDialog({
      body: this.workflow.workflow_queue,
      type: 'WORKFLOW',
      title: this.workflow.workflow_queue.workflow.name,
      relatedIds: uniqWith(entitiesIds, isEqual),
    });
  }

  openComments(event: Event): void {
    event.stopPropagation();

    this.commentsService
      .getComments('workflow_queues', this.workflow.workflow_queue.id)
      .pipe(take(1))
      .subscribe((res) => {
        this.dialog.open(CommentsDialogComponent, {
          data: {
            comments: res.data,
            transactionId: this.workflow.workflow_queue.id,
            transactionType: 'workflow_queues',
            height: 55,
          },
          width: '600px',
        });
      });
  }

  getBlockersString(blockers: Blocker[]): string {
    let blockersString = '';

    blockers.forEach((blocker) => (blockersString += `${blocker.code}\n`));

    return blockersString;
  }

  handleSort(event: Event, column: { label: string; prop: string }): void {
    event.stopPropagation();

    if (!column.prop) return;

    if (column.label === this.sort.label) {
      this.sort.type === 'ASC' ? (this.sort.type = 'DESC') : (this.sort.type = 'ASC');
    } else this.sort = { label: column.label, type: 'ASC' };

    this.refreshWorkflowList.emit(
      this.sort.label
        ? { prop: column.prop, type: this.sort.type }
        : { prop: 'workflow_queue.created', type: 'DESC' },
    );
  }
}
